/* ===== main.js ===== */
/* スクロール連動のフェードイン（ユーザー指示 2026-10-14。Figma に無い演出）
   - main 内の各 section 直下の要素に .lp-fade を付け、画面に入ったら .lp-visible を付ける（テーマ側の .fade と衝突しないよう LP 専用名）
   - 同じ section 内では順番に 0.1s ずつ遅らせる
   - prefers-reduced-motion の環境では何もしない（検証用スクリーンショットは
     Edge/Chrome に --force-prefers-reduced-motion を付けると演出なしで撮れる） */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var sections = document.querySelectorAll('.kani-lp .lp-main section:not(.hero)');
  var targets = [];
  Array.prototype.forEach.call(sections, function (section) {
    var i = 0;
    Array.prototype.forEach.call(section.children, function (el) {
      el.classList.add('lp-fade');
      el.style.transitionDelay = (i * 0.1) + 's';
      targets.push(el);
      i += 1;
    });
  });

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('lp-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -5% 0px' });

  targets.forEach(function (el) { observer.observe(el); });
})();
